import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { Spinner } from "./Spinner";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { Faded } from "baby-i-am-faded";
import classNames from "classnames";
import { signIn, useSession } from "next-auth/react";
import React, { useEffect, useState } from "react";
import "../global";
import { Link } from "./Link";
import { useThrowingFn } from "../utils";
import { PageContainer } from "./PageContainer";
import { Button } from "./Button";
// const getSubscriptionMemoized = memoize(getSubscription, { isPromise: true })
export function PricingSlider(_param) {
    var refetchSubscription = function refetchSubscription() {
        setSubscription(undefined);
        getSubscription().then(function(subscription) {
            if (subscription) {
                setSubscription(subscription);
            }
        });
    };
    var _products = _param.products, products = _products === void 0 ? [] : _products, _animate = _param.animate, animate = _animate === void 0 ? false : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onCheckout = _param.onCheckout, trialDays = _param.trialDays, _promptLogin = _param.promptLogin, promptLogin = _promptLogin === void 0 ? function() {
        signIn();
    } : _promptLogin, updatePlan = _param.updatePlan, _hideUpgradeButton = _param.hideUpgradeButton, hideUpgradeButton = _hideUpgradeButton === void 0 ? false : _hideUpgradeButton, getSubscription = _param.getSubscription, features = _param.features, manageSubscriptionHandler = _param.manageSubscriptionHandler, _pricesCurrency = _param.pricesCurrency, pricesCurrency = _pricesCurrency === void 0 ? "usd" : _pricesCurrency, _allowYearlyBilling = _param.allowYearlyBilling, allowYearlyBilling = _allowYearlyBilling === void 0 ? true : _allowYearlyBilling, needMoreEmail = _param.needMoreEmail, rest = _object_without_properties(_param, [
        "products",
        "animate",
        "className",
        "isLoading",
        "onCheckout",
        "trialDays",
        "promptLogin",
        "updatePlan",
        "hideUpgradeButton",
        "getSubscription",
        "features",
        "manageSubscriptionHandler",
        "pricesCurrency",
        "allowYearlyBilling",
        "needMoreEmail"
    ]);
    var ref = useState(), subscription = ref[0], setSubscription = ref[1];
    var ref1 = useSession(), status = ref1.status, session = ref1.data;
    var ref2 = useState("month"), billingInterval = ref2[0], setBillingInterval = ref2[1];
    useEffect(function() {
        void _async_to_generator(function() {
            var subscription;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated") {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getSubscription()
                        ];
                    case 1:
                        subscription = _state.sent();
                        if (subscription) {
                            setSubscription(subscription);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    var FadedComponent = animate ? Faded : "div";
    var ranges = products.sort(function(a, b) {
        var ref, ref1, ref2, ref3;
        return ((ref1 = a === null || a === void 0 ? void 0 : (ref = a.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
            return one.currency === pricesCurrency;
        })) === null || ref1 === void 0 ? void 0 : ref1.unitAmount) - ((ref3 = b === null || b === void 0 ? void 0 : (ref2 = b.prices) === null || ref2 === void 0 ? void 0 : ref2.find(function(one) {
            return one.currency === pricesCurrency;
        })) === null || ref3 === void 0 ? void 0 : ref3.unitAmount);
    }).filter(function(x) {
        if (status === "authenticated") {
            return x.prices.every(function(p) {
                return p.unitAmount > 0;
            });
        }
        return true;
    }).map(function(product) {
        var ref;
        var price = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
            return one.currency === pricesCurrency;
        });
        if (!price) {
            return null;
        }
        if (product.billing_type !== billingInterval) {
            return null;
        }
        return {
            price: price.unitAmount,
            limits: product.limits,
            productId: product.productId
        };
    }).filter(Boolean);
    var ref3 = useState(-1), currentProductIndex = ref3[0], setCurrentProductIndex = ref3[1];
    useEffect(function() {
        if (!(ranges === null || ranges === void 0 ? void 0 : ranges.length)) {
            return setCurrentProductIndex(-1);
        }
        setCurrentProductIndex(0);
    }, [
        ranges.length,
        billingInterval
    ]);
    var currentRange = ranges[currentProductIndex] || null;
    var price = function() {
        if (!currentRange) {
            return null;
        }
        var p = (currentRange === null || currentRange === void 0 ? void 0 : currentRange.price) / 100;
        return p;
    }();
    var ref4 = useThrowingFn({
        fn: /*#__PURE__*/ _async_to_generator(function() {
            var ref, productId, ref1, ref2;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        productId = currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId;
                        if (!productId) {
                            return [
                                2
                            ];
                        }
                        if (status !== "authenticated" && promptLogin) {
                            return [
                                2,
                                promptLogin()
                            ];
                        }
                        if (!(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id)) {
                            throw new Error("User ID is missing");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            6,
                            9
                        ]);
                        if (!subscription) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            updatePlan({
                                subscriptionId: subscription.id,
                                planId: productId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 100);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            refetchSubscription()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        return [
                            2,
                            {
                                skipToast: true
                            }
                        ];
                    case 6:
                        if (!onCheckout) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            onCheckout({
                                productId: productId,
                                isChangePlan: Boolean(subscription),
                                email: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
                                userId: session === null || session === void 0 ? void 0 : (ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.id
                            })
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })
    }), handlePricingClick = ref4.fn, clickIsLoading = ref4.isLoading;
    var buttonText = function() {
        if ((subscription === null || subscription === void 0 ? void 0 : subscription.productId) === (currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId)) {
            return "Current plan";
        }
        if (subscription) {
            return "Change plan";
        }
        if (!session) {
            return "Start free trial";
        }
        return "Upgrade";
    }();
    var disabled = (subscription === null || subscription === void 0 ? void 0 : subscription.productId) === (currentRange === null || currentRange === void 0 ? void 0 : currentRange.productId) || isLoading;
    // console.log({ currentRange })
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({
        id: "pricing"
    }, rest), {
        children: /*#__PURE__*/ _jsxs(FadedComponent, _object_spread_props(_object_spread({}, animate && {
            cascade: true,
            whenInView: true,
            triggerOnce: true
        }), {
            className: classNames("w-full max-w-[900px] shadow-xl self-center rounded relative", "px-12 p-8 mx-auto gap-6 flex-col flex bg-white", "dark:bg-gray-800", className),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-wrap gap-4 font-medium",
                    children: [
                        isLoading && /*#__PURE__*/ _jsx(Spinner, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex items-start gap-8",
                            children: Object.keys((currentRange === null || currentRange === void 0 ? void 0 : currentRange.limits) || {}).map(function(k, i) {
                                var limit = currentRange === null || currentRange === void 0 ? void 0 : currentRange.limits[k];
                                if (typeof limit === "number") {
                                    limit = formatBigNumber(limit);
                                }
                                if (limit === false) {
                                    return null;
                                }
                                if (limit === true) {
                                    limit = "";
                                }
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "space-y-1",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "opacity-80 truncate uppercase",
                                            children: k
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "font-semibold text-3xl",
                                            children: limit
                                        })
                                    ]
                                }, k + i);
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "grow"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "opacity-80 text-right",
                                    children: "PRICE"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "font-semibold text-3xl truncate",
                                    children: [
                                        "$",
                                        price,
                                        " ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "opacity-70 font-medium",
                                            children: " / mo"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(RangeSlider, {
                    value: currentProductIndex,
                    onChange: function(e) {
                        var ref;
                        var v = (ref = Number(e.target.value)) !== null && ref !== void 0 ? ref : -1;
                        // console.log({ v })
                        setCurrentProductIndex(v);
                    },
                    min: 0,
                    max: (ranges === null || ranges === void 0 ? void 0 : ranges.length) - 1,
                    step: 1
                }),
                allowYearlyBilling && /*#__PURE__*/ _jsx(BillingIntervalSelect, {
                    billingInterval: billingInterval,
                    setBillingInterval: setBillingInterval
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "uppercase font-semibold text-sm opacity-80",
                            children: "what's included"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "grow border-t-2"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "grid grid-cols-3 gap-y-8 gap-x-8",
                    children: features.map(function(feature, i) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-2 justify-center items-center",
                            children: [
                                i % 3 === 2 && /*#__PURE__*/ _jsx("div", {
                                    className: "grow"
                                }),
                                /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                    className: "h-5 dark:fill-green-300 fill-green-500"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "",
                                    children: feature
                                }),
                                i % 3 === 0 && /*#__PURE__*/ _jsx("div", {
                                    className: "grow"
                                })
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex mt-4 justify-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-2",
                        children: [
                            !hideUpgradeButton && /*#__PURE__*/ _jsx(Button, {
                                "aria-label": "buy",
                                onClick: handlePricingClick,
                                disabled: disabled,
                                // bg='blue.500'
                                // bgDark='blue.200'
                                isLoading: clickIsLoading,
                                biggerOnHover: true,
                                className: "font-bold !px-6",
                                children: buttonText
                            }),
                            Boolean(trialDays) && !subscription && !session && /*#__PURE__*/ _jsxs("div", {
                                className: "opacity-70 text-center font-medium text-xs",
                                children: [
                                    trialDays,
                                    " days free trial"
                                ]
                            })
                        ]
                    })
                }),
                subscription && manageSubscriptionHandler ? /*#__PURE__*/ _jsx(Link, {
                    className: "mx-auto !mb-0",
                    onClick: function(e) {
                        e.preventDefault();
                        manageSubscriptionHandler();
                    },
                    href: "",
                    children: "Manage subscription"
                }) : /*#__PURE__*/ _jsxs(FadedComponent, {
                    className: "text-center mx-auto !mb-0 opacity-80 text-sm",
                    children: [
                        "Need more?",
                        " ",
                        /*#__PURE__*/ _jsx(Link, {
                            href: "mailto:".concat(needMoreEmail, "?subject=").concat(encodeURIComponent("Need a custom plan")),
                            children: "Contact me"
                        })
                    ]
                })
            ]
        }))
    }));
}
function BillingIntervalSelect(param) {
    var billingInterval = param.billingInterval, setBillingInterval = param.setBillingInterval;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative self-center bg-gray-200 rounded-lg", "p-0.5 flex"),
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return setBillingInterval("month");
                },
                type: "button",
                className: classNames("whitespace-nowrap w-1/2 text-sm text-gray-700", "rounded-lg relative py-2 font-medium sm:w-auto", "sm:px-8 focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "month",
                    "bg-transparent": billingInterval !== "month"
                }),
                children: "Monthly billing"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return setBillingInterval("year");
                },
                type: "button",
                className: classNames("whitespace-nowrap w-1/2 text-sm text-gray-700", "rounded-lg relative py-2 font-medium bg-white", "sm:w-auto sm:px-8 focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "year",
                    "bg-transparent": billingInterval !== "year"
                }),
                children: "Yearly billing"
            })
        ]
    });
}
export function RangeSlider(_param) {
    var min = _param.min, max = _param.max, _bg = _param.bg, bg = _bg === void 0 ? "#388bd2" : _bg, step = _param.step, rest = _object_without_properties(_param, [
        "min",
        "max",
        "bg",
        "step"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: _JSXStyle.dynamic([
            [
                "21825d0e90ea0342",
                [
                    bg,
                    bg,
                    bg
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({
                type: "range",
                min: min,
                max: max,
                step: step
            }, rest), {
                className: _JSXStyle.dynamic([
                    [
                        "21825d0e90ea0342",
                        [
                            bg,
                            bg,
                            bg
                        ]
                    ]
                ]) + " " + (rest && rest.className != null && rest.className || "range px-3")
            })),
            _jsx(_JSXStyle, {
                id: "21825d0e90ea0342",
                dynamic: [
                    bg,
                    bg,
                    bg
                ],
                children: 'input[type="range"].__jsx-style-dynamic-selector{-moz-appearance:none;-webkit-appearance:none;background:rgba(0,0,0,.1);-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;height:6px;width:100%;margin-top:15px;margin-bottom:15px;outline:0}.dark input[type="range"].__jsx-style-dynamic-selector{background:rgba(255,255,255,.1)}input[type="range"].__jsx-style-dynamic-selector::-webkit-slider-thumb{-moz-appearance:none;-ms-appearance:none;appearance:none;-webkit-box-shadow:0 0 40px rgba(0,0,0,.2);-moz-box-shadow:0 0 40px rgba(0,0,0,.2);box-shadow:0 0 40px rgba(0,0,0,.2);-webkit-appearance:none;background-color:'.concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-moz-range-thumb{background-color:').concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;border:0;border:0;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-ms-thumb{background-color:').concat(bg, ';background-image:url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%20.5v7L12%204zM0%204l4%203.5v-7z%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E");background-position:center;background-repeat:no-repeat;border:0;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;height:36px;width:36px}input[type="range"].__jsx-style-dynamic-selector::-moz-focus-outer{border:0}')
            })
        ]
    });
}
import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en";
function formatBigNumber(n) {
    var formatter = new Intl.NumberFormat("en-US", {
        compactDisplay: "short",
        notation: "compact"
    });
    return formatter.format(n);
}
